<div class="client-info-section-item">
  <h3 class="client-info-section-item-title">{{ label }}</h3>
  <p *ngIf="!isLoading; else valueSkeleton" class="client-info-section-item-value">{{ value }}</p>
  <ng-template #valueSkeleton>
    <span class="skeleton client-info-section-item-value-skeleton"></span>
  </ng-template>
</div>
